import React, { useRef } from 'react';
import equal from 'fast-deep-equal';

export default class FieldRow extends React.Component {
  constructor(props) {
    super(props);

    this.targetRef = React.createRef();

    this.state = {
      edited: false,
      factor: this.props.factor,
      value: 0,
      emmision: 0,
      relative: 0,
      cost: 0,
    };
  }

  startMath(event) {
    const { factor } = this.state;

    this.setState({ value: Number(this.targetRef.current.value) }, () => {
      if (this.state.value !== 0)
        this.setState({ edited: true }, () => {
          this.calcEmmision(factor);
        });
    });
  }

  calcEmmision(factor) {
    const { value } = this.state;

    this.setState({ emmision: (value * factor).toFixed(2) }, () => {
      this.props.changeRelative(), this.props.setFilled(), this.calcPrice();
    });
  }

  calcRelative() {
    const relativeValue = ((this.state.emmision / this.props.total) * 100).toFixed(2);

    this.setState({ relative: relativeValue });
  }

  calcPrice() {
    const price = (this.state.emmision * 0.06).toFixed(2);

    this.setState({ cost: price });
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) this.calcRelative();
  }

  render() {
    return (
      <div className='co2calculator__row'>
        <div className='co2calculator__inputWrapper co2calculator__inputWrapper--enabled'>
          <label htmlFor={`${this.props.name}_input`} className={`co2calculator__label`}>
            {this.props.name}
          </label>
          <input
            ref={this.targetRef}
            onChange={() => {
              this.startMath(event);
            }}
            name={`${this.props.name}_input`}
            type='tel'
            inputMode='numeric'
            pattern='[0-9]*'
            className={`co2calculator__input co2calculator__input--enabled co2calculator__input--${this.props.unit}`}
          ></input>
          <span className='co2calculator__unitSpan'>{this.props.unit} p/y</span>
        </div>

        <div className='co2calculator__inputWrapper co2calculator__inputWrapper--display'>
          <label
            htmlFor={`${this.props.name}_co2`}
            className={`co2calculator__label co2calculator__label--display`}
          >
            kg
          </label>
          <input
            value={`${this.state.emmision}`}
            name={`${this.props.name}_co2`}
            type='number'
            className={`co2calculator__input co2calculator__input--display co2calculator__input--display--${this.state.edited.toString()}`}
            disabled
          ></input>
        </div>

        <div className='co2calculator__inputWrapper co2calculator__inputWrapper--display co2calculator__inputWrapper--relative'>
          <label
            htmlFor={`${this.props.name}_rel`}
            className={`co2calculator__label co2calculator__label--display`}
          >
            %
          </label>
          <input
            value={`${this.state.relative}`}
            name={`${this.props.name}_rel`}
            type='number'
            className='co2calculator__input co2calculator__input--display co2calculator__input--relative'
            disabled
          ></input>
        </div>
      </div>
    );
  }
}
